import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4d368ff8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "PopupResult" }
const _hoisted_2 = ["src"]
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "result-contain" }, [
  /*#__PURE__*/_createElementVNode("h1", { class: "title" }, "บันทึกข้อมูลเรียบร้อยแล้ว"),
  /*#__PURE__*/_createElementVNode("p", { class: "description" }, [
    /*#__PURE__*/_createTextVNode(" ประกาศรายชื่อผู้โชคดีที่ร่วมสนุก"),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" ทาง Facebook: "),
    /*#__PURE__*/_createElementVNode("a", {
      href: "https://www.facebook.com/cpmeijithailand",
      target: "_blank"
    }, "CP-Meiji Thailand")
  ])
], -1))
const _hoisted_4 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("img", {
      src: `${require('@/assets/images/home/line-result.svg')}`
    }, null, 8, _hoisted_2),
    _hoisted_3,
    _createElementVNode("img", {
      src: `${require('@/assets/images/home/line-result.svg')}`
    }, null, 8, _hoisted_4)
  ]))
}